<template>
  <van-overlay show class-name="breakpoint overflow-y-auto" z-index="1000">
    <div class="h-full bg-white text-center breakpoint-container">
      <img src="/assets/img/gray-logo.png" alt="" width="128" />
      <div class="mb-6 mt-3" style="line-height: 24px">
        <div>您之前已经回答了 {{ data }} 题</div>
        <div>是否继续上次回答？</div>
      </div>
      <div class="py-6">
        <van-button block type="primary" @click="onContinue">继续答题</van-button>
        <van-button class="mt-3" block @click="onRestart">重新开始</van-button>
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  name: 'Breakpoint',
  props: {
    data: {
      type: Number,
      default: 0
    }
  },
  methods: {
    onRestart() {
      this.$emit('restart')
    },
    onContinue() {
      this.$emit('continue')
    }
  }
}
</script>

<style scoped lang="scss">
.breakpoint-container {
  padding: 10vh 64px 0;
  box-sizing: border-box;
}
</style>
